import Link from "next/link";
import React from "react";
import { useTranslation } from "@/app/i18n/i18n-client";
import { allPortfolio } from "@/data/portfolio";

export default function Breadcumb2({ locale, slug }) {
  const { t } = useTranslation(locale, "projects"); 

  // Find project by slug
  const project = allPortfolio.find((proj) => proj.slug === slug);

  // Handle case where project is not found
  if (!project) {
    console.error("❌ ERROR: No portfolio found for slug:", slug);
    return null; // Don't render anything if project doesn't exist
  }

  return (
    <div className="breadcumb-wrapper style2 bg-smoke">
      <div className="container-fluid">
        <div className="breadcumb-content">
          <ul className="breadcumb-menu">
            <li>
              <Link scroll={false} href="/">KauFast</Link>
            </li>
            <li>
              <Link scroll={false} href="/project">{t("prj")}</Link>
            </li>
            <li>{t(project.title)}</li> 
          </ul>
        </div>
      </div>
    </div>
  );
}
